import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';

export default () => {
  return (
    <SectionContainer
      id='what-to-expect-when-filing-a-disability-claim-page-content'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            variant='p'
            nextElement='link'>
            We are sorry that you or the insured has experienced an unexpected change in health. We recognize how difficult this can be and we are here to provide assistance during the claims process.
          </Typography>
          <Link
            id="notice-of-disability-form-link"
            variant='primaryDeemphasize'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            linkUrl="https://northwesternmutual.com/notice-of-disability-form/"
            ariaLabel='Disability Insurance &#45; Submit a claim: Access the form'
          >
            Access the form
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
